import { useMemo } from "react";
import { Entity } from "@common/types/entity";
import { useEntitiesContexts } from "./useEntitiesContexts";

/**
 * Entities whose transaction enrichment is paused while migrated accounting
 * data is being analyzed, limited to entities that already have synced
 * transactions (otherwise there is nothing waiting on categorization).
 */
export function useEnrichmentPausedEntities(): Entity[] {
    const entitiesContexts = useEntitiesContexts();

    return useMemo(
        () =>
            entitiesContexts
                ?.filter(
                    (context) =>
                        context.entity.transactionEnrichmentPausedAt !== null &&
                        context.financialAccounts.some(
                            (account) => account.transactionsSyncedAt !== null,
                        ),
                )
                .map((context) => context.entity) ?? [],
        [entitiesContexts],
    );
}
